// src/services/kpiService.js
import { get } from "../helpers/api_helper";

export const getKPIs = async ({ period = "all" }) =>
  (await get(`stats/overview?period=${period}`)).data;

export const getInsights = async ({ period = "30d" }) =>
  (await get(`insights?period=${period}`)).data;
